module.exports = __webpack_public_path__ + "52c8507a92eb88208eb938643173e900.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/monsters/monster-5.png
// module id = 1062
// module chunks = 0